import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { AutoFocus } from 'primeng/autofocus';
import { Checkbox, CheckboxChangeEvent } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { I18nService } from '../../../../../core/services/i18n.service';
import { CustomerGroup } from '../../../../enums/organisation/customer-group';
import { PaymentMethodName } from '../../../../enums/payment/payment-method-name';
import { PaymentData } from '../../../../interfaces/payment/payment-data';
import { PaymentInvalidFlags } from '../../../../interfaces/payment/payment-invalid-flags';

@Component({
  selector: 'admin-payment-type-config',
  imports: [
    ToggleSwitch,
    FormsModule,
    InputText,
    AutoFocus,
    Checkbox,
    NgClass,
    Select
  ],
  templateUrl: './admin-payment-type-config.component.html',
})
export class AdminPaymentTypeConfigComponent {

  i18n = inject(I18nService);

  @Input() paymentData: PaymentData;
  @Input() paymentInvalidFlags: PaymentInvalidFlags;
  @Input() customerGroup: CustomerGroup;
  @Input() chargebackCards: SelectItem[] = [];


  protected readonly PaymentMethodName = PaymentMethodName;

  /**
   * reset invalid flag if payone partner id is empty
   * @protected
   */
  protected checkForEmptyPartnerId() {
    if (this.paymentData?.payOnePartnerId.length === 0) {
      this.paymentInvalidFlags.payOnePartnerId = false;
    }
  }

  /**
   * reset chargeback project Id if chargeback was unchecked
   * @param checked
   * @protected
   */
  protected onCreditCardEnabledChanged(checked: boolean) {
    if (!checked) {
      this.paymentData.chargebackProjectId = null;
    }
  }

  protected readonly CustomerGroup = CustomerGroup;
}
